import React, { useState } from "react";
import MyTeamTable from "../../../Components/layouts/StudentCourse/MyTeamTable";
import { Modal } from "../../../Components/share/modal/Modal";
import MyTeamModal from "../../../Components/layouts/StudentCourse/MyTeamModal";
import DashCard from "../../../Components/share/cards/DashCard";

function Myteam() {
  const [modalbtn, setModalbtn] = useState(false);

  return (
    <div>
      <div className="flex justify-between items-center">
        <h4 className="text-[2rem] text-purple-dark font-bold">گروه ققنوس</h4>
      </div>
      <DashCard className=" py-[0.7rem] px-[1.1rem]  mt-[2.1rem]">
        <p className=" text-[#212121E5] text-[1.4rem] font-bold leading-[2.4rem]">
          ایده:{" "}
        </p>
        <p className=" text-[#212121E5] text-[1.4rem] font-normal leading-[2.4rem]">
          لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
          استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
          ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و
          کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی
          در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می
          طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی
          الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این
          صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و
          شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای
          اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده
          قرار گیرد.
        </p>
      </DashCard>
      <MyTeamTable list={list} showModal={setModalbtn} header={header}>
        <Modal show={modalbtn}>
          <MyTeamModal close={setModalbtn} />
        </Modal>
      </MyTeamTable>
    </div>
  );
}

export default Myteam;
const header = [
  { title: "نام" },
  { title: "سمت" },
  { title: "ایمیل" },
  { title: "تخصص" },
];
const list = [
  {
    id: 1,
    name: "علی رجبی",
    date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    test: "رمینا",
    btn: "مدیر کسب و کار",
  },
  {
    id: 2,
    name: "علی رجبی",
    date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    test: "رمینا",
    btn: "مدیر کسب و کار",
  },
  {
    id: 3,
    name: "علی رجبی",
    date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    test: "شپنا",
    btn: "مدیر کسب و کار",
  },
  {
    id: 4,
    name: "علی رجبی",
    date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    test: "شپنا",
    btn: "مدیر کسب و کار",
  },
  {
    id: 5,
    name: "علی رجبی",
    date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    test: "شپنا",
    btn: "مدیر کسب و کار",
  },
  {
    id: 6,
    name: "علی رجبی",
    date: "یکشنبه ۱۴ فروردین ۱۴۰۱ ساعت ۲۰:۳۵ ",
    test: "شپنا",
    btn: "مدیر کسب و کار",
  },
];
